import {FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import React from "react";

import {CAP_LEVELS} from "../domain/CapLevels";

export default function CapLevelSelect(
    {
        isNonEditable,
        isServiceTypeCapSegmented,
        currentCapLevel,
        handleCapLevelChanged,
    }
) {
    return <>
        {
            (() => {
                if (isNonEditable) {
                    return <TextField
                        id='cap-level-select'
                        label='CAP Level'
                        value={currentCapLevel}
                        variant='standard'
                        slotProps={{input: {readOnly: true}}} />;
                } else if (!isServiceTypeCapSegmented) {
                    return <TextField
                        id='cap-level-select'
                        label='CAP Level'
                        value={currentCapLevel}
                        variant='standard'
                        slotProps={{input: {readOnly: true}}} />;
                } else {
                    return <FormControl fullWidth style={{minWidth: 120}}>
                        <InputLabel id="cap-level-select-label">CAP Level</InputLabel>
                        <Select
                            labelId='cap-level-select-label'
                            id='cap-level-select'
                            label='CAP Level'
                            onChange={e => handleCapLevelChanged(e.target.value)}
                            disabled={!isServiceTypeCapSegmented}
                            value={currentCapLevel}
                            MenuProps={{MenuListProps: {sx: {paddingBottom: 0}}}}
                        >
                            {
                                CAP_LEVELS.map(level => {
                                    return <MenuItem key={level.key} value={level.key}>{level.name}</MenuItem>;
                                })
                            }
                        </Select>
                    </FormControl>;
                }
            })()
        }
    </>;
}